(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EventCollectionsDeleteController',EventCollectionsDeleteController);

    EventCollectionsDeleteController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'EventCollections'];

    function EventCollectionsDeleteController($uibModalInstance, parameters, SoopkitchenUtils, EventCollections) {
        
        var vm = this;
        
        /**** Properties ****/
        vm.waiting = false;
        vm.label = parameters.label;
        
        /**** Methods ****/
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function successDeleting () {
            vm.waiting = false;
            $uibModalInstance.dismiss('cancel');
            SoopkitchenUtils.invokeSweetAlert('Event Collection Deleted', vm.label + ' has been deleted', 'success', function () {
                location.reload();
            })
        }
        
        function failureDeleting (response) {
            vm.waiting = false;
            $uibModalInstance.dismiss('cancel');
            SoopkitchenUtils.prettyError(response);
        }
        
        function confirmDelete(label) {
            EventCollections.deleteEventCollection(label, successDeleting, failureDeleting);
        }
    }
})();
